const preTitle = `
    <h3 class="c9" dir="rtl" id="obituaries">
        <span class="c2">הספדים</span>
    </h3>
`;

export default preTitle;
